import PropTypes from 'prop-types';
import './UnreadBadge.css';

/**
 * A component to display a count of unread messages in a red circle.
 */
const UnreadBadge = ({ count }) => {
  if (count <= 0) return null;
  return (
    <div className="unread-badge">
      <span className="unread-badge-count">{count}</span>
    </div>
  );
};

UnreadBadge.propTypes = {
  /** The number to display inside the badge. */
  count: PropTypes.number.isRequired,
};

export default UnreadBadge;